/**
 * @generated SignedSource<<f52b47d7045c938aad67f9a17abe7d2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemovePolicyCollectionMutation$variables = {
  uuid: string;
};
export type RemovePolicyCollectionMutation$data = {
  readonly removePolicyCollection: {
    readonly collection: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type RemovePolicyCollectionMutation = {
  response: RemovePolicyCollectionMutation$data;
  variables: RemovePolicyCollectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "uuid"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemovePolicyCollectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PolicyCollectionPayload",
        "kind": "LinkedField",
        "name": "removePolicyCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollection",
            "kind": "LinkedField",
            "name": "collection",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemovePolicyCollectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PolicyCollectionPayload",
        "kind": "LinkedField",
        "name": "removePolicyCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollection",
            "kind": "LinkedField",
            "name": "collection",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "decb4a462a0f27ea22b1594607800e14",
    "id": null,
    "metadata": {},
    "name": "RemovePolicyCollectionMutation",
    "operationKind": "mutation",
    "text": "mutation RemovePolicyCollectionMutation(\n  $uuid: String!\n) {\n  removePolicyCollection(uuid: $uuid) {\n    collection {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af358cd4c521ec53facef7a74bf4b807";

export default node;
